import { createReducer, on } from '@ngrx/store';
import { initialStatus, Status } from '../../../../status.interface';
import * as actions from './actions';
import { RemoteDomain } from './model';

export const featureKey = 'exoRemoteDomain';

export interface State extends Status {
    data: RemoteDomain;
}

export const initialState: State = {
    data: undefined,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,

    on(actions.fetchExoRemoteDomainSuccess, (state, { data }) => ({ ...state, loaded: true, error: null, data })),
    on(actions.fetchExoRemoteDomainFailure, (state, { error }) => ({ ...state, error })),
    on(actions.updateExoRemoteDomain, (state) => ({ ...state, updating: true, error: null })),
    on(actions.updateExoRemoteDomainSuccess, (state, { data }) => ({
        ...state,
        updating: false,
        error: null,
        data: { ...state.data, ...data },
    })),
    on(actions.updateExoRemoteDomainFailure, (state, { error }) => ({ ...state, updating: false, error })),
);

export const selectItem = (state: State) => state.data;
